export const importTypes = {
  productImport: 'productImport',
  productDataImport: 'productDataImport',
  productAllInOneImport: 'productAllInOneImport',
  productCreationImport: 'productCreationImport',
  productInternalIdImport: 'productInternalIdImport',
  productMasterListImport: 'productMasterListImport',
  portfolioProductExternalIdImport: 'portfolioProductExternalIdImport',
  profileDataImport: 'profileDataImport',
};
